import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const store = (data) => {
    return api.post('/dashboard/send', data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível fazer o envio')
        })
}

export default {
    store
}
